import React from 'react';
import { css } from 'emotion';
import { Logos, WordPressDotComLogo } from './Logos';
import {
  LogoWrapper,
  WordPressSectionHero,
  DesktopHeading,
  MobileHeading,
} from './styles';

const HEADING_LABEL = 'In partnership with WordPress.com';

export function WordPressHero() {
  return (
    <WordPressSectionHero>
      <DesktopHeading
        aria-label={HEADING_LABEL}
        className={css`
          margin: 0;
        `}
      >
        <Logos />
      </DesktopHeading>
      <MobileHeading
        aria-label={HEADING_LABEL}
        className={css`
          margin: 0;
        `}
      >
        In partnership with
        <LogoWrapper
          aria-hidden={true}
          className={css`
            width: 200px;
            margin: auto;
            padding-top: 4px;
          `}
        >
          <WordPressDotComLogo />
        </LogoWrapper>
      </MobileHeading>
    </WordPressSectionHero>
  );
}
